"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossFade = void 0;
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var styles = __importStar(require("./CrossFade.css"));
var Retrocog_1 = require("../Retrocog");
var useUniqueKey_1 = __importDefault(require("./useUniqueKey"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var CrossFade = function (_a) {
    var elementKey = _a.elementKey, children = _a.children;
    var key = (0, useUniqueKey_1.default)(elementKey);
    return (react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: styles.wrapper },
        react_1.default.createElement(Retrocog_1.RetrocogTransition, { key: key, timeout: 800, mountOnEnter: true, unmountOnExit: true, className: function (status) { return styles.content({ status: status }); }, onEnter: utils_1.forceReflow }, children)));
};
exports.CrossFade = CrossFade;
